export default "__VITE_ASSET__Cp4eGkNG__"